<template>
  <div class="container">
    <div class="middle">
      <!-- 找回密码标题 -->
      <div class="find_password">
        <span class="find_color">
          找回密码
        </span>
      </div>
      <!-- 表单 -->
      <div class="fp_middle">
        <div class="fp_top">
          <div class="fp_zhuangtai">
            <span class="zhuangtilan"></span>
            <span class="zhuangtilan2"></span>
            <div class="fp_yanzheng">
              <span>1</span>
              <h3>验证手机号</h3>
            </div>
            <div class="fp_chongzhi">
              <span>2</span>
              <h3>重置手机号</h3>
            </div>
            <div class="fp_czsuccess">
              <span>3</span>
              <h3>重置成功</h3>
            </div>
          </div>
        </div>



        <div class="fp_down" v-if="step===1">

          <ul>
            <li><input type="telphone" id="telphone" placeholder="请输入注册时的手机号" v-model="sjh"></li>
            <li class="li11">
              <input type="text" id="verityCode" placeholder="请输入验证码" v-model="yzm">
              <img class="yzm" @click="renderVerifyCodeImg" :src="yzIMG" alt="">
            </li>
            <li>
              <input type="text" id="msgVerifyCode" v-model="sjyzm2" placeholder="请输入短信验证码">
              <button class="fp_get" @click="sjymm">获取短信验证码</button>
            </li>
          </ul>
          

          <div class="fp_submit">
            <button @click="zhmm">找回密码</button>
          </div>

        </div>




        <div class="fp_down" v-if="step===2">
          <ul>
            <li><input style="marginTop:20px" type="telphone" id="telphone" placeholder="请输入输入新密码" v-model="newMM1"></li>
            <li class="li11">
              <input style="marginTop:20px" type="text" id="telphone" placeholder="确认新密码" v-model="newMM2">
            </li>
          </ul>
          

          <div class="fp_submit">
            <button @click="editMM">确认修改</button>
          </div>
        </div>





        <div v-if="step===3">
          <div class="success">修改密码成功！</div>
        </div>
        
      </div>
    </div>
  </div>
</template>


<script>
import {encryptedData} from '../../../../../common/utils/Encryption/JSEncrypt'
export default {
  data(){
    return{
      //输入框输入的验证码
      yzm:'',
      //手机号
      sjh:'',

       //存放验证码图片的路径
      yzIMG:'',
      // 存放验证码的路径
      yzmData:'',
      //存放手机验证码
      sjyzm1:'',
      //输入的手机验证码
      sjyzm2:'',

      //第几步
      step:1,


      //新密码
      newMM1:'',
      // 确认新密码
      newMM2:''
      
    }
  },
  methods:{
    //获取验证码信息
    renderVerifyCodeImg(){
       this.post({
        url:'renderVerifyCodeImg',
      },(res)=>{
        console.log(res);
        this.yzIMG=res.data.base64Img
        this.yzmData=res.data.captchaKey
      })
    },
    //获取了手机验证码
    sjymm(){
      var reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!reg.test(this.sjh)) return this.$message.error('手机号格式错误')
       this.post({
          url:'sendShortMessageCode',
          data:{
            phone:this.sjh,
            verifyCode:8,
            verifyCodeKey:8
          }
        },(res)=>{
          if(res.code===200){
            console.log(res.data.verifyCode);
            this.$message.success('获取短信验证码成功')
            this.sjyzm1=res.data.verifyCode
          }
        })
    },
    //点击了找回密码     这里要做验证验证码，和验证手机号，验证手机验证码的操作
    zhmm(){
     this.post({
        url:'checkCaptcha',
        data:{
          inputCode:this.yzm,
          codeKey:this.yzmData
        }
      },(res)=>{
        if(res.code==200&&this.sjyzm1==this.sjyzm2&&this.sjyzm1!==''){
          this.step=2
        }else{
          return this.$message.error('验证码输入错误')
        }
      })
    },
    //点击了修改密码      这里要做修改密码的操作
    editMM(){
      if(this.newMM1==='') return this.$message.error('请输入密码')
      if(this.newMM1!==this.newMM2) return this.$message.error('两次密码输入不一致')

      this.post({
        url:'resetPasswd',
        data:{
          confirmPasswd:encryptedData(this.newMM1),
          type:0,
          username:this.sjh
        }
      },(res)=>{
        if(res.code!==200) return this.$message.error('重置密码失败，请稍后重试')
        this.$message.success('修改密码成功')
        this.step=3
      })

    }
  },
  
  created(){
    this.renderVerifyCodeImg()
  }
}
</script>


<style scoped>
a {
    text-decoration: none;
    color: #ffffff;
}
p {
    text-align: justify;
}
span {
    display: inline-block;
}
li{
  list-style: none;
}
.container{
  min-height: 752px;
}
.middle{
  height: 400px;
}
.find_password {
    height: 30px;
    width: 100%;
    border-bottom: 1px solid #c00;
    line-height: 30px;
    text-align: left;
    text-indent: 20px;
}
.find_color{
    color: gray;
    font-size: 18px;
    height: 20px;
    position: relative;
    top: -5px;
}
.fp_middle {
    width: 440px;
    height: 350px;
    margin: 0px auto;
    padding-top: 15px;
}
.fp_top {
    height: 80px;
    width: 100%;
    background-color: #c00;
    color: #FFFFFF;
    font-size: 14px;
    text-align: center;
    position: relative;
}
.fp_zhuangtai {
    height: 50px;
    width: 400px;
    margin: 0px auto;
    position: absolute;
    top: 25px;
    left: 30px;
}
.fp_zhuangtai span {
    font-size: 20px;
    color: lightgray;
}
.zhuangtilan {
    height: 1px;
    width: 90px;
    position: absolute;
    background-color: gainsboro;
    top: 15px;
    left: 90px;
}
.zhuangtilan2 {
    height: 1px;
    width: 90px;
    position: absolute;
    background-color: gainsboro;
    top: 15px;
    right: 90px;
}
.fp_zhuangtai div {
    float: left;
    width: 120px;
    height: 60px;
    margin-left: 10px;
}
.fp_zhuangtai span {
    font-size: 20px;
    color: lightgray;
}
.fp_zhuangtai h3 {
    font-weight: 400;
    color: lightgray;
    font-size: 16px;
}
.fp_zhuangtai span {
    font-size: 20px;
    color: lightgray;
}
.fp_zhuangtai h3 {
    font-weight: 400;
    color: lightgray;
    font-size: 16px;
}
.fp_zhuangtai span {
    font-size: 20px;
    color: lightgray;
}
.fp_zhuangtai h3 {
    font-weight: 400;
    color: lightgray;
    font-size: 16px;
}


/* 下放表单 */
.fp_down {
    padding-top: 10px;
    background-color: #eff0ee;
    height: 250px;
    width: 100%;
    position: relative;
}
.fp_down input {
    line-height: 30px;
    text-indent: 10px;
}
.fp_down ul{
  padding-left: 51px;
}
.li11{
  overflow: hidden;
}
.yzm{
    font-size: 14px;
    cursor: pointer;
    width: 100px;
    height: 30px;
    border: 1px solid black;
    margin-left: 20px;
    vertical-align: middle;
}
#telphone {
    height: 34px;
    width: 354px;
    margin-top: 0px;
}
#verityCode, #msgVerifyCode {
    width: 204px;
    height: 34px;
    margin-top: 10px;
    border: 1px solid black;
}
.fp_get {
    margin-left: 15px;
    height: 30px;
    width: 130px;
    display: inline-block;
    font-size: 16px;
    background-color: #c00;
    color: #FFFFFF;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    border-radius: 4px;
}
.fp_submit {
    width: 350px;
    height: 30px;
    text-align: center;
    line-height: 20px;
    margin-left: 50px;
    margin-top: 10px;
    font-size: 18px;
    color: #FFFFFF;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 50px;
}
.fp_submit button{
  cursor: pointer;
    background-color: #c00;
    color: white;
    height: 40px;
    width: 100%;
    border-bottom-style: none;
    font-size: 16px;
    border: 0px;
}
.success{
  width: 100%;
  height: 100px;
  color: #c00;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/sy/pages/zhmm.vue